/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { FaEdit } from 'react-icons/fa';
import { connect } from 'react-redux';
import { colors } from '_styles';
import { AiFillMinusSquare, AiFillPlusSquare } from 'react-icons/ai';
import moment from 'moment';
import { _ } from '_locales';
import { ReCaptcha } from 'react-recaptcha-v3';
import { Button } from '../../Education/components';
import { LoadingSpinner } from '../../../components';
import { cts_secure } from '../../../app/cts';
import apis, { siteKey } from '../../../app/apis';
import { convertPhoneNumberToDigits } from '../heplers';
import stoughton from '../config';

const ConfirmDetails = ({
  mainColor,
  currentPage,
  setCurrentPage,
  contactInfo,
  pageNames,
  bpItems,
  selectedDate,
  addressDetails,
  bpData,
  dropdownSelection,
  hasPayment,
  paymentSystem,
}) => {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState();
  const [cartId, setCartId] = useState();
  const { main_color } = mainColor;
  const [token, setToken] = useState('');
  const stoughtonSubmitButtonRef = useRef();

  const fee = Object.values(bpItems)[0]?.options[0]?.fee;
  const hasFee = fee && fee !== '$0.00';
  const removeItemHandler = (index) => {
    const copy = { ...data };
    let { quantity } = copy[index];
    quantity -= 1;
    if (quantity === -1) return;
    copy[index] = {
      ...copy[index],
      quantity,
      total: quantity * copy[index].price,
    };
    setData(copy);
  };

  const addItemHandler = (index) => {
    const copy = { ...data };
    let { quantity } = copy[index];
    if (quantity >= copy[index].max_qty) return;
    quantity += 1;
    copy[index] = {
      ...copy[index],
      quantity,
      total: quantity * copy[index].price,
    };
    setData(copy);
  };

  const editHandler = (pageName) => {
    const index = pageNames.findIndex((i) => i.name === pageName);
    setCurrentPage(index);
  };

  useEffect(() => {
    const modifiedData = {};
    const allOptions = [];
    for (const el in bpItems) {
      allOptions.push(
        ...bpItems[el].options
          .filter((item) => item.count)
          .map((item) => ({
            code: 'Bulk Pick-up',
            item: item.mat_nm,
            price: parseFloat(item.fee.replace('$', '')),
            quantity: item.count,
            total: parseFloat(item.fee.replace('$', '')) * item.count,
            id: item.mat_id,
            max_qty: item.max_qty,
            description: item.description,
          }))
      );

      allOptions.forEach((item, index) => {
        modifiedData[index + 1] = item;
      });
    }

    setData(modifiedData);
  }, []);

  const verifyCallback = (generatedToken) => {
    setToken(generatedToken);
  };

  const onSubmit = async () => {
    const copyData = { ...data };
    for (const key in copyData) {
      if (copyData[key].quantity === 0) {
        delete copyData[key];
      }
    }

    const selectedItems = Object.values(copyData).map((item) => ({
      id: item.id,
      quantity: item.quantity,
    }));
    try {
      setIsLoading(true);
      const items = {
        token,
        can_contact: true,
        from_help: true,
        problem_type: 'PICKUP_REQUEST',
        project_id: addressDetails.projectId,
        district_id: addressDetails.districtId,
        contact_full_nm: `${contactInfo.firstName} ${contactInfo.lastName}`,
        location_text: addressDetails.address, // full address
        contact_phone_nbr: convertPhoneNumberToDigits(contactInfo.phone),
        problem_dscr: `Pickup request for the following items ${Object.values(
          copyData
        )
          .map((item) => `${item.item} x${item.quantity}`)
          .join(', ')}`,
        contact_email_addr: contactInfo.email,
        // return_url: 'htt://somestupic.com',
        selected_dt: moment(selectedDate).utc().format('YYYY-MM-DD'),
        bulk_pickup: JSON.stringify({ mats: selectedItems }),
        extra_dropdown: dropdownSelection,
      };

      const payLoad = new FormData();

      Object.entries(items).map((item) => payLoad.append(item[0], item[1]));
      const response = await cts_secure('post', apis.submitBPRequest(), payLoad);

      if (!response.data?.success) {
        throw new Error('Something went wrong!');
      }
      if (response.data?.cart_id) {
        setCartId(response.data.cart_id);
      }

      if (!hasPayment) {
        setCurrentPage(
          pageNames.findIndex((item) => item.name === 'confirmation')
        );
      } else if (paymentSystem === 'Stoughton') {
        stoughtonSubmitButtonRef.current.click();
      }

      setIsLoading(false);
      setError(false);
    } catch (e) {
      setIsLoading(false);
      setError(true);
    }
    return null;
  };

  if (!data) return <></>;

  return (
    <Container>
      {!isLoading && (
        <ReCaptcha
          sitekey={siteKey}
          action="reportProblem"
          verifyCallback={verifyCallback}
        />
      )}
      <TextHeader>{_('bulkPickup.confirm_details')}</TextHeader>

      <View>
        {contactInfo.firstName && (
          <View style={sectionWrapper}>
            <Text style={textStyle}>
              {_('bulkPickup.name')}
            </Text>
            <View style={sectionWrapperEnd}>
              <View style={{ ...flexAlignCenter, gap: 6 }}>
                <Text style={sectionEndText}>
                  {contactInfo.firstName}
                  {' '}
                  {contactInfo.lastName}
                </Text>
                <FaEdit onClick={() => editHandler('contact-information')} fontSize={23} color="rgb(24, 123, 193)" cursor="pointer" />
              </View>
            </View>
          </View>
        )}
        <View style={sectionWrapper}>
          <Text style={{ ...textStyle, textOverflow: 'unset', }}>
            Address
          </Text>
          <View>
            <View style={{ ...flexAlignCenter, gap: 6, flex: 1, }}>
              <Text
                style={{ ...sectionEndText, textAlign: 'right', }}
              >
                {addressDetails.address}
              </Text>
              <FaEdit
                onClick={() => editHandler('address-search')}
                fontSize={23}
                color="rgb(24, 123, 193)"
                cursor="pointer"
              />
            </View>
          </View>
        </View>
        {contactInfo.phone && (
          <View style={sectionWrapper}>
            <Text style={textStyle}>
              {_('bulkPickup.telephone')}
            </Text>
            <View style={sectionWrapperEnd}>
              <View style={{ ...flexAlignCenter, gap: 6 }}>
                <Text
                  style={sectionEndText}
                >
                  {contactInfo.phone}
                </Text>
                <FaEdit
                  onClick={() => editHandler('contact-information')}
                  fontSize={23}
                  color="rgb(24, 123, 193)"
                  cursor="pointer"
                />
              </View>
            </View>
          </View>
        )}
        {contactInfo.email && (
          <View style={sectionWrapperStart}>
            <Text style={textStyle}>
              {_('bulkPickup.email')}
            </Text>
            <View style={sectionWrapperEnd}>
              <View style={{ ...flexAlignCenter, gap: 6 }}>
                <Text
                  style={sectionEndText}
                >
                  {contactInfo.email}
                </Text>
                <FaEdit onClick={() => editHandler('contact-information')} fontSize={23} color="rgb(24, 123, 193)" cursor="pointer" />
              </View>
            </View>
          </View>
        )}
        <View style={sectionWrapperStart}>
          <Text style={textStyle}>
            {_('bulkPickup.pick_up_day')}
          </Text>
          <View>
            <View style={{ ...flexAlignCenter, gap: 6, flex: 1, }}>
              <Text style={sectionEndText}>
                {moment(selectedDate).utc().format('dddd, MMMM D')}
              </Text>
              <FaEdit
                onClick={() => editHandler('pickup-date')}
                fontSize={23}
                color="rgb(24, 123, 193)"
                cursor="pointer"
              />
            </View>
          </View>
        </View>
        {bpData.bulk_pickup_config?.extra_dropdown_title
          && bpData.bulk_pickup_config?.has_extra_dropdown && (
            <View style={sectionWrapperStart}>
              <Text style={textStyle}>
                {bpData.bulk_pickup_config?.extra_dropdown_title}
              </Text>
              <View>
                <View
                  style={{ ...flexAlignCenter, gap: 6, flex: 1, }}
                >
                  <Text style={sectionEndText}>
                    {dropdownSelection}
                  </Text>
                  <FaEdit
                    onClick={() => editHandler('extra-information')}
                    fontSize={23}
                    color="rgb(24, 123, 193)"
                    cursor="pointer"
                  />
                </View>
              </View>
            </View>
          )}
        <View style={flexBetween}>
          <Text
            style={{
              ...sectionHeaderText, padding: '0 15px', flex: 5,
            }}
          >
            {_('bulkPickup.accepted_items')}
          </Text>
          <Text
            style={{
              ...sectionHeaderText, padding: '0 20px', flex: 2, textAlign: hasPayment || hasFee ? 'center' : 'right', marginRight: hasPayment || hasFee ? 0 : 20,
            }}
          >
            {_('bulkPickup.qty')}
          </Text>
          {hasPayment || hasFee ? (
            <Text
              style={{
                ...sectionHeaderText, padding: '0 15px', textAlign: 'right', flex: 2,
              }}
            >
              {_('bulkPickup.fee_each')}
            </Text>
          ) : null}
        </View>

        <View style={{ margin: '4px 0', }}>
          {Object.values(data).map((item, index) => (
            <View style={{ ...flexBetween, }}>
              <Text
                style={{
                  padding: '0 15px', fontWeight: 400, color: '#000', flex: 5,
                }}
              >
                {item.item}
              </Text>
              <View
                style={{
                  ...flexAlignCenter,
                  justifyContent: hasPayment || hasFee ? 'center' : 'flex-end',
                  gap: 7,
                  padding: '0 15px',
                  flex: 2,
                }}
              >
                <AiFillMinusSquare
                  cursor="pointer"
                  fontSize={30}
                  color={item.count === 0 ? '#D9D9D9' : '#FF1D1E'}
                  onClick={() => removeItemHandler(index + 1)}
                />
                <Text Text style={{ fontWeight: 'bold' }}>
                  {item.quantity}
                </Text>
                <AiFillPlusSquare
                  cursor="pointer"
                  fontSize={30}
                  color="#177BC2"
                  onClick={() => addItemHandler(index + 1)}
                />
              </View>
              {hasPayment || hasFee ? (
                <Text
                  style={{
                    ...sectionEndText, padding: '0 15px', flex: 2, textAlign: 'right',
                  }}
                >
                  $
                  {item.total}
                </Text>
              ) : null}
            </View>
          ))}
        </View>

        {hasPayment || hasFee ? (
          <View style={{ margin: '4px 0', }}>
            <View style={flexBetween}>
              <Text style={{
                padding: '0 15px', fontWeight: 600, color: '#000', flex: 7,
              }}
              >
                {_('bulkPickup.total_fee')}
              </Text>

              <Text style={{
                ...sectionEndText, padding: '0 15px', flex: 2, textAlign: 'right',
              }}
              >
                $
                {Object.values(data).reduce(
                  (a, b) => Number(a) + Number(b.total),
                  0
                )}
              </Text>
            </View>
          </View>
        ) : null}
      </View>

      <Error>{error && _('bulkPickup.something_went_wrong')}</Error>

      {isLoading && (
        <div
          style={{ transform: 'translateX(100px) scale(0.5)', display: 'flex' }}
        >
          <LoadingSpinner style={{ marginLeft: 'auto' }} />
        </div>
      )}

      <View
        style={{
          display: 'flex', gap: 20, justifyContent: 'flex-end', padding: '20px',
        }}
      >
        <Button
          backgroundColor="fff"
          color={main_color || colors.RC_ACTION}
          aria-label={'Back'}
          fontSize="16px"
          padding="12px 24px"
          onClick={() => setCurrentPage(currentPage - 1)}
        >
          {_('bulkPickup.back')}
        </Button>
        <Button
          mainColor={main_color || false}
          aria-label={'Proceed to Payment'}
          onClick={onSubmit}
          fontSize="16px"
          padding="12px 24px"
        >
          {hasPayment
            ? _('bulkPickup.proceed_to_payment')
            : _('recycleRight.done')}
        </Button>

      </View>

      <div style={{ display: 'none' }}>
        <form
          action={stoughton.stoughtonPaymentProd}
          method="post"
        >
          <input type="text" name="numTransactions" value="1" />
          <input type="hidden" name="RTIType" value="formPost" />
          <input
            type="hidden"
            name="1_AccessKey"
            value={stoughton.accesKey}
          />
          <input type="hidden" name="1_CustomerID" value={stoughton.customerId} />
          <input type="hidden" name="1_TransactionID" value={stoughton.transactionId} />
          <input type="hidden" name="1_Qty" value="1" />
          <input
            type="hidden"
            name="1_Amount"
            value={`${Object.values(data).reduce(
              (a, b) => Number(a) + Number(b.total),
              0
            )}`}
          />
          <input type="hidden" name={stoughton.cartId} value={cartId} />
          <input
            type="hidden"
            name="returnURL"
            value={`${document.URL}#rc-bulk-payment=${cartId}`}
          />
          <input type="text" name="returnButtonText" value="Done" />
          <input
            type="hidden"
            name="1_PostBackURL"
            value={stoughton.stoughtonPostBack}
          />
          <input
            ref={stoughtonSubmitButtonRef}
            type="submit"
            name="submit"
            value="PostData"
          />
        </form>
      </div>
    </Container>
  );
};

export default connect(
  (state) => ({
    mainColor: state.config.templateColour
      ? JSON.parse(state.config.templateColour)
      : {},
  }),
  null
)(ConfirmDetails);

const OpacityAnimation = keyframes`
  from { opacity: 0;}
  to { opacity:1;}
`;
const View = styled.div`
  animation: ${OpacityAnimation} 0.5s;
`;

const TextHeader = styled.h3`
  letter-spacing: 1px;
  cursor: pointer;
  padding: 15px 10px 15px 9px !important;
  font-size: 18px !important;
  color: rgb(64, 64, 64) !important;
  font-weight: 600 !important;
  font-family: Roboto, sans-serif !important;
  border-bottom: 2px solid rgb(231, 236, 239);
  margin-bottom: 0px !important;
`;

const Text = styled.p`
  color: rgb(64, 64, 64);
  opacity: 0.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: 16px !important;
  font-family: Roboto, sans-serif !important;
`;

const Container = styled.div`
  box-sizing: border-box;
  /* padding: 20px; */
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 18px 0px;
  margin-top: 15px;
  margin-bottom: 35px;
`;

const Error = styled.p`
  color: rgb(178, 1, 7);
  margin: 20px 23px 0 0;
  font-size: 13px;
  text-align: right;
`;

const textStyle = {
  fontSize: '14px', fontWeight: 400, color: '#757575',
};

const flexBetween = {
  display: 'flex', justifyContent: 'space-between',
};

const flexAlignCenter = {
  display: 'flex', alignItems: 'center',
};

const sectionWrapper = {
  ...flexBetween, padding: '0 20px',
};

const sectionWrapperEnd = {
  ...flexAlignCenter, width: '60%', gap: 10, justifyContent: 'flex-end',
};

const sectionEndText = {
  fontWeight: 'bold', color: 'rgb(24, 123, 193)', letterSpacing: 0.3, flex: 1,
};

const sectionHeaderText = {
  fontSize: '14px', color: '#6C7293', letterSpacing: 1, fontWeight: 600,
};

const sectionWrapperStart = {
  ...flexBetween, borderBottom: '2px solid rgb(231, 236, 239)', padding: '0 20px',
};
